import Vue from 'vue'
import VueGraph from 'vue-graph'

Vue.use(VueGraph)

